export default __webpack_public_path__ + "static/media/bin.a861784c.svg";